import * as React from 'react';

const Logo = ({dark = false, ...props}) => {
    const src = dark
        ? 'https://firebasestorage.googleapis.com/v0/b/jodifranklin-415b8.appspot.com/o/plural_logo_dark.png?alt=media&token=21932073-3238-4f1a-83fb-2fa4561581f6'
        : 'https://firebasestorage.googleapis.com/v0/b/jodifranklin-415b8.appspot.com/o/plural_logo_light.png?alt=media&token=4939f12c-7eb0-4adf-bfa6-dec20e6fdc73';

    return <img src={src} alt="Jodi Franklin" {...props} />;
};

export default Logo;
